<template>
  <div class="station-container-outer">
    <div class="station-container">
      <GuideStationHeader :liveDetail="liveDetail" />
      <div class="station-body-container">
        <a-row class="station-body">
          <a-col :span="16" class="body-left">
            <a-row class="display-screen">
              <div class="main-player">
                <MainPreview
                  :liveId="liveId"
                  :liveDetail="liveDetail"
                  :previewLayout="previewLayout"
                  :previewPanelList="previewPanelList"
                  @updateCardList="selectCardList"
                  @cancelLayoutChange="cancelLayoutChange"
                  :streamMap="streamMap"
                  :layoutChangeMsg="layoutChangeMsg"
                  @getSpeakerTeacherDevicePanelAndPreviewPanelListTemp="
                    getSpeakerTeacherDevicePanelAndPreviewPanelListTemp
                  "
                  @operationDOM="operationDOM"
                  :isPreviewing="isPreviewing"
                  @changeIsPreviewing="changeIsPreviewing"
                  :delLayoutChangeStream="delLayoutChangeStream"
                />
              </div>
            </a-row>
            <a-row class="layout-list-wrap">
              <div class="layout-tip">
                <span>
                  当前授课模式：{{
                    (VIDEO_LAYOUT_LIST.find((i) => i.type === liveDetail.casterMode) || {}).typeText || '--'
                  }}
                </span>
                <span>预览中模式：{{ previewLayout.typeText || '--' }}</span>
              </div>
              <LayoutList
                :previewLayout="previewLayout"
                :liveDetail="liveDetail"
                @selectLayout="selectLayout"
                @operationDOM="operationDOM"
              />
            </a-row>
          </a-col>
          <a-col :span="8" class="body-right">
            <div class="tab-list">
              <a-tabs :default-active-key="curTabType" @change="changeTab">
                <a-tab-pane v-for="tab in tabList" :key="tab.type" :tab="tab.name"></a-tab-pane>
              </a-tabs>
            </div>
            <div class="tab-content-wrap scrollableBar">
              <div class="live-set-content" v-show="curTabType === 'liveSetting'">
                <LiveSettingTab
                  :liveId="liveId"
                  :classroomList="classroomList"
                  :liveDetail="liveDetail"
                  :clientForZRTC="clientForZRTC"
                  @getLiveDetail="getLiveDetail"
                />
              </div>
              <div class="guide-station" v-show="curTabType === 'guideStation'">
                <GuideStationTab
                  :liveId="liveId"
                  :socketMsg="socketMsg"
                  :liveDetail="liveDetail"
                  :layoutChangeMsg="layoutChangeMsg"
                  @selectCardList="selectCardList"
                  :streamMap="streamMap"
                  :clientForZRTC="clientForZRTC"
                  :classroomList="classroomList"
                  @operationDOM="operationDOM"
                  @getSpeakerCardList="getSpeakerCardList"
                  @getListenerCardList="getListenerCardList"
                  @unsubscribeVideo="unsubscribeVideo"
                  @subscribeVideo="subscribeVideo"
                  :isPreviewing="isPreviewing"
                  @changeIsPreviewing="changeIsPreviewing"
                  @delLayoutChangePanel="delLayoutChangePanel"
                  @getLiveDetail="getLiveDetail"
                />
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <audio src="" id="audio_container"></audio>
    <play-button @operationForPlay="operationForPlay" v-if="autoPlayError" />
  </div>
</template>

<script>
import GuideStationHeader from './comp/GuideStationHeader'
import LayoutList from './comp/LayoutList'
import GuideStationTab from './comp/GuideStationTab'
import LiveSettingTab from './comp/LiveSettingTab'
import MainPreview from './comp/MainPreview'
import { checkRes } from '../../utils/tool'
import { getLiveInfo, checkAuthority } from '@/server/api/guideStation'
import { VIDEO_LAYOUT_LIST, LIVE_STATUS } from '@/consts/live'
import { SOCKET_MSG_TYPE } from '@/consts/socketMsg'
import { VIDEO_LEVEL } from '@/consts/camera'
import { ROLE } from '@/consts/user'

export default {
  name: 'GuideStation', // 手工导播
  props: {
    showDialog: Boolean
  },
  components: {
    GuideStationHeader,
    GuideStationTab,
    LiveSettingTab,
    LayoutList,
    MainPreview,
    'play-button': () => import('@/components/playButton/index.vue')
  },
  data() {
    return {
      socketMsg: {},
      clientForZRTC: null,
      listenedOnSignalMessage: false,

      VIDEO_LAYOUT_LIST,
      liveId: this.$route.query.liveId,
      curTabType: 'guideStation',
      tabList: [
        {
          name: '直播设置',
          type: 'liveSetting'
        },
        {
          name: '导播台',
          type: 'guideStation'
        }
      ],
      liveDetail: {},
      // allStreamInfo: {},

      isPreviewing: false, // 是否在手工操作中,手工操作时，接收到layoutchange只保存，不处理

      previewLayout: {}, // 预览模式布局
      layoutChangeMsg: {}, // 信令layoutchange的content内容
      previewPanelList: [],
      delLayoutChangeStream: {}, // layoutchange中需要删除的streamId

      streamMap: new Map(),
      classroomList: [],
      classroomListFictitious: [],
      speakerCardList: [],
      listenerCardList: [],
      speakerTeacherDevicePanel: {},
      previewPanelListTemp: [],
      autoPlayError: false
    }
  },
  async created() {
    await this.goCheckAuthority()
  },
  async mounted() {
    await this.getLiveDetail()
    if (this.liveDetail.status !== LIVE_STATUS.ING) return
    if (!this.clientForZRTC) {
      this.clientForZRTC = await this.ZRTCInit()
    }
    this.getSocketMessage()
    // 订阅所有的流：
    // this.initStream(this.classroomListFictitious)
    // 订阅mix流：
    this.subscribMixStream()
  },
  methods: {
    // 是否在手工导播操作中
    changeIsPreviewing(bl) {
      this.isPreviewing = bl
    },
    // 订阅mix流：
    async subscribMixStream() {
      if (!Object.keys(this.liveDetail) || !this.clientForZRTC) return
      const streamId = this.liveDetail.mixStreamId
      if (!streamId) return
      const res = await this.clientForZRTC.subscribe(streamId, 'audio')
      this.streamMap.set(res.streamId, res)
      this.$nextTick(async () => {
        const audioContainer = document.querySelector('#audio_container')
        if (audioContainer) {
          if (audioContainer.srcObject !== this.streamMap.get(streamId)) {
            audioContainer.srcObject = this.streamMap.get(streamId)
          }
        }
        try {
          await audioContainer.play()
          this.autoPlayError = false
        } catch (err) {
          if (String(err).includes('first')) {
            this.autoPlayError = true
          } else {
            this.autoPlayError = false
          }
        }
      })
    },
    operationForPlay() {
      const audioContainer = document.querySelector('#audio_container')
      if (audioContainer) {
        audioContainer.play()
        this.autoPlayError = false
      }
    },
    // 校验权限
    async goCheckAuthority() {
      const self = this
      const res = await checkAuthority({ liveId: this.liveId })
      checkRes({
        res,
        success(data) {
          if (!data.rt) {
            self.$router.push({
              name: 'NoPermission'
            })
          }
        },
        failed(err) {
          self.$router.push({
            name: 'NoPermission'
          })
        }
      })
    },
    // 选中流卡片变化
    selectCardList(list, rule) {
      // 预览模式下
      if (!this.isPreviewing && rule !== 'updatePreviewPanel') return
      console.log(3240005, '预览流', list)
      this.previewPanelList = list
    },

    // layoutchange中需要被删除的streamId
    delLayoutChangePanel(streamId) {
      this.delLayoutChangeStream = {streamId}
    },
    // 切换tab
    changeTab(tab) {
      this.curTabType = tab
    },

    // 选中布局
    selectLayout(layout) {
      this.previewLayout = layout
      this.changeIsPreviewing(true)
    },
    ZRTCInit() {
      return new Promise(async (resolve) => {
        const client = ZRTC2.init(this.liveId)
        client.setClientRole('audience')
        client.setBaseUrl({
          // hilive: 'https://tju-hilive.zhihuishu.com',
          hilive: 'https://zhs-hilive.zhihuishu.com',
          // 'zhihuishu-livecourse-desktop': 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com'
          'zhihuishu-livecourse-desktop': 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com'
        })
        try {
          await client.joinAudienceRoom()
          console.log('joinRoom success')
          resolve(client)
        } catch (err) {
          console.log(err, 'joinRoom_err')
          return this.$message.error('抱歉，当前加入直播人数已达上限，无法加入！')
        }
      })
    },
    getSocketMessage() {
      if (!this.clientForZRTC) return
      if (this.listenedOnSignalMessage) return
      this.clientForZRTC.onSignalMessage((data) => {
        this.listenedOnSignalMessage = true
        this.socketMsg = data.response
        this.dealSocketMsg(data.response)
      })
    },
    async dealSocketMsg(message) {
      const { type, content = {} } = message
      switch (type) {
        case SOCKET_MSG_TYPE.LAYOUT_CHANGE: // 布局变化
          this.layoutChangeMsg = content
          if (!this.isPreviewing) {
            this.previewPanelList = content.panels
            this.getClassroomListFictitious()
          }
          VIDEO_LAYOUT_LIST.forEach(layout => {
            const exist = layout.layoutParams.find(i => i.layout === content.layout)
            if (exist) {
              // 改变当前授课模式
              this.liveDetail.casterMode = layout.type
              // 非预览模式下，预览中模式才能随当前授课模式改变
              if (!this.isPreviewing) {
                this.previewLayout = layout
              }
            }
          })

          break
        case SOCKET_MSG_TYPE.USER_LIST_ON_MIC:
          console.log(content, 'content_USER_LIST_ON_MIC')
          this.classroomList = content || []
          // this.initStream(this.classroomList)
          break
        case SOCKET_MSG_TYPE.USER_PUBLISHED:
          console.log(content, 'content_USER_PUBLISHED')
          switch (content.mediaType) {
            case 'screen':
              const screenItem = {
                ...content,
                role: ROLE.SHARE_SCREEN,
                currentVideoDevice: [
                  {
                    streamId: content.streamId
                  }
                ]
              }
              const shareScreenUser = this.classroomList.find(
                (item) => item.uid === screenItem.uid && item.role !== ROLE.SHARE_SCREEN
              )
              // 兼容智慧听课（智慧听课也有共享屏幕），非主讲不展示共享图标：
              const canContinue = shareScreenUser?.role === ROLE.SPEAKER
              const masterIndex = this.classroomList.findIndex((item) => item.role == ROLE.SPEAKER)
              const findTheScreenItem = this.classroomList.find(
                (item) => item.role === screenItem.role && item.uid === screenItem.uid
              )
              if (canContinue && !findTheScreenItem) {
                this.classroomList.splice(masterIndex + 1, 0, screenItem)
              }
              break
            case 'video':
              {
                const updateItem = this.classroomList.find((item) => item.uid === content.uid) || {}
                const updateIndex = this.classroomList.findIndex((item) => item.uid === content.uid)
                const newClassroom = {
                  ...updateItem,
                  currentVideoDevice: [
                    { ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }
                  ]
                }
                updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
              }
              break
          }
          break
        case SOCKET_MSG_TYPE.USER_UNPUBLISHED:
          console.log(content, 'content_USER_UNPUBLISHED')
          switch (content.mediaType) {
            case 'screen':
              const shareScreenIndex = this.classroomList.findIndex(
                (item) => item.uid === content.uid && item.role == ROLE.SHARE_SCREEN
              )
              shareScreenIndex >= 0 && this.classroomList.splice(shareScreenIndex, 1)
              break
          }
          break
        case SOCKET_MSG_TYPE.LAST_INFO_DETAIL:
          console.log(content, 'content_LAST_INFO_DETAIL')
          const objReal = JSON.parse(JSON.stringify(content))
          delete objReal.autoStreamStatus
          const map = new Map()
          Object.values(objReal).forEach((item) => {
            item.streamInfo.forEach((v) => {
              if (v.mediaType === 'video' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'video', v.streamId)
              }
              if (v.mediaType === 'audio' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'audio', v.streamId)
              }
              if (v.mediaType === 'screen' && v.status === 'published' && v.mediaLabel === 'screenStream') {
                const contentNew = {
                  ...item,
                  role: ROLE.SHARE_SCREEN,
                  currentVideoDevice: [
                    {
                      streamId: v.streamId
                    }
                  ]
                }
                const shareScreenUser = this.classroomList.find(
                  (item) => item.uid === contentNew.uid && item.role !== ROLE.SHARE_SCREEN
                )
                // 兼容智慧听课（智慧听课也有共享屏幕），非主讲不展示共享图标：
                const canContinue = shareScreenUser?.role === ROLE.SPEAKER
                const masterIndex = this.classroomList.findIndex((v) => v.role == ROLE.SPEAKER)
                const findTheScreenItem = this.classroomList.find(
                  (item) => item.role === contentNew.role && item.uid === contentNew.uid
                )
                if (canContinue && !findTheScreenItem) {
                  this.classroomList.splice(masterIndex + 1, 0, contentNew)
                }
              }
            })
          })
          break
      }
    },
    // 获取直播详情
    async getLiveDetail() {
      const self = this
      const res = await getLiveInfo({ liveId: this.liveId })
      checkRes({
        res,
        success(data) {
          self.liveDetail = data.rt
          self.previewLayout = VIDEO_LAYOUT_LIST.find((i) => i.type === data.rt.casterMode) || {}
        },
        failed() {
          self.$message.error('获取课程详情失败')
        }
      })
    },
    initStream(list) {
      const audioStreamIdList = []
      const videoStreamIdList = []
      list.forEach((item) => {
        ;(item.currentAudioDevice || []).forEach((v) => {
          if (v.streamId) audioStreamIdList.push(v.streamId)
        })
        ;(item.currentVideoDevice || []).forEach((v) => {
          if (v.streamId) videoStreamIdList.push(v.streamId)
        })
      })
      const intersectionForAudioStreamId = audioStreamIdList.filter(
        (item) => !new Set(this.preAudioStreamIdList).has(item)
      )
      const intersectionForVideoStreamId = videoStreamIdList.filter(
        (item) => !new Set(this.preVideoStreamIdList).has(item)
      )
      this.preAudioStreamIdList = audioStreamIdList
      this.preAudioStreamIdList = videoStreamIdList
      console.log(intersectionForAudioStreamId, 'intersectionForAudioStreamId')
      console.log(intersectionForVideoStreamId, 'intersectionForVideoStreamId')
      for (let i = 0, len = intersectionForAudioStreamId.length; i < len; i++) {
        ;(async (i) => {
          try {
            console.log(intersectionForAudioStreamId[i], 'intersectionForAudioStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForAudioStreamId[i], 'audio')
            console.log(res, 'intersectionForAudioStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationDOM()
            this.operationDOMRightList()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
      for (let i = 0, len = intersectionForVideoStreamId.length; i < len; i++) {
        ;(async (i) => {
          try {
            console.log(intersectionForVideoStreamId[i], 'intersectionForVideoStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForVideoStreamId[i], undefined, VIDEO_LEVEL.MID)
            console.log(res, 'intersectionForVideoStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationDOM()
            this.operationDOMRightList()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
    },
    cancelLayoutChange() {
      const { layoutChangeMsg } = this
      this.previewLayout = VIDEO_LAYOUT_LIST.find((i) => i.type === this.liveDetail.casterMode) || {}
      this.layoutChangeMsg = {...layoutChangeMsg}
      this.changeIsPreviewing(false)
      this.previewPanelList = this.layoutChangeMsg.panels
    },
    operationDOM() {
      // 处理左边的画面：
      this.$nextTick(() => {
        if (!this.previewPanelList.length) return

        const previewPanelList0FullScreen = document.querySelector('#previewPanelList0FullScreen')
        if (previewPanelList0FullScreen) {
          if (previewPanelList0FullScreen.srcObject !== this.streamMap.get(this.previewPanelList[0].streamId)) {
            previewPanelList0FullScreen.srcObject = this.streamMap.get(this.previewPanelList[0].streamId)
          }
        }

        const previewPanelList0Sidebar = document.querySelector('#previewPanelList0Sidebar')
        if (previewPanelList0Sidebar) {
          if (previewPanelList0Sidebar.srcObject !== this.streamMap.get(this.previewPanelList[0].streamId)) {
            previewPanelList0Sidebar.srcObject = this.streamMap.get(this.previewPanelList[0].streamId)
          }
        }

        const previewPanelList1Sidebar = document.querySelector('#previewPanelList1Sidebar')
        if (previewPanelList1Sidebar) {
          if (previewPanelList1Sidebar.srcObject !== this.streamMap.get(this.previewPanelList[1].streamId)) {
            previewPanelList1Sidebar.srcObject = this.streamMap.get(this.previewPanelList[1].streamId)
          }
        }

        const previewPanelList2Sidebar = document.querySelector('#previewPanelList2Sidebar')
        if (previewPanelList2Sidebar) {
          if (previewPanelList2Sidebar.srcObject !== this.streamMap.get(this.previewPanelList[2].streamId)) {
            previewPanelList2Sidebar.srcObject = this.streamMap.get(this.previewPanelList[2].streamId)
          }
        }

        const previewPanelList0Float = document.querySelector('#previewPanelList0Float')
        if (previewPanelList0Float) {
          if (previewPanelList0Float.srcObject !== this.streamMap.get(this.previewPanelList[0].streamId)) {
            previewPanelList0Float.srcObject = this.streamMap.get(this.previewPanelList[0].streamId)
          }
        }

        const previewPanelList1Float = document.querySelector('#previewPanelList1Float')
        if (previewPanelList1Float) {
          if (previewPanelList1Float.srcObject !== this.streamMap.get(this.previewPanelList[1].streamId)) {
            previewPanelList1Float.srcObject = this.streamMap.get(this.previewPanelList[1].streamId)
          }
        }

        const previewPanelList0Grid = document.querySelector('#previewPanelList0Grid')
        if (previewPanelList0Grid) {
          if (previewPanelList0Grid.srcObject !== this.streamMap.get(this.previewPanelList[0].streamId)) {
            previewPanelList0Grid.srcObject = this.streamMap.get(this.previewPanelList[0].streamId)
          }
        }

        const previewPanelList1Grid = document.querySelector('#previewPanelList1Grid')
        if (previewPanelList1Grid) {
          if (previewPanelList1Grid.srcObject !== this.streamMap.get(this.previewPanelList[1].streamId)) {
            previewPanelList1Grid.srcObject = this.streamMap.get(this.previewPanelList[1].streamId)
          }
        }

        const previewPanelList2Grid = document.querySelector('#previewPanelList2Grid')
        if (previewPanelList2Grid) {
          if (previewPanelList2Grid.srcObject !== this.streamMap.get(this.previewPanelList[2].streamId)) {
            previewPanelList2Grid.srcObject = this.streamMap.get(this.previewPanelList[2].streamId)
          }
        }

        const previewPanelList3Grid = document.querySelector('#previewPanelList3Grid')
        if (previewPanelList3Grid) {
          if (previewPanelList3Grid.srcObject !== this.streamMap.get(this.previewPanelList[3].streamId)) {
            previewPanelList3Grid.srcObject = this.streamMap.get(this.previewPanelList[3].streamId)
          }
        }

        const speakerTeacherDevicePanelIntelligentFollowing = document.querySelector(
          '#speakerTeacherDevicePanelIntelligentFollowing'
        )
        if (speakerTeacherDevicePanelIntelligentFollowing) {
          if (
            speakerTeacherDevicePanelIntelligentFollowing.srcObject !==
            this.streamMap.get(this.speakerTeacherDevicePanel.streamId)
          ) {
            speakerTeacherDevicePanelIntelligentFollowing.srcObject = this.streamMap.get(
              this.speakerTeacherDevicePanel.streamId
            )
          }
        }

        const previewPanelListTemp0IntelligentFollowing = document.querySelector(
          '#previewPanelListTemp0IntelligentFollowing'
        )
        if (previewPanelListTemp0IntelligentFollowing) {
          if (
            previewPanelListTemp0IntelligentFollowing.srcObject !==
            this.streamMap.get((this.previewPanelListTemp[0] || {}).streamId)
          ) {
            previewPanelListTemp0IntelligentFollowing.srcObject = this.streamMap.get(
              (this.previewPanelListTemp[0] || {}).streamId
            )
          }
        }
      })
    },
    getSpeakerTeacherDevicePanelAndPreviewPanelListTemp(speakerTeacherDevicePanel, previewPanelListTemp) {
      this.speakerTeacherDevicePanel = speakerTeacherDevicePanel
      this.previewPanelListTemp = previewPanelListTemp
    },
    getClassroomListFictitious() {
      const list = [...this.speakerCardList, ...this.listenerCardList, ...this.previewPanelList].map((item) => {
        return {
          ...item,
          currentVideoDevice: [
            {
              streamId:
                item.role === ROLE.SPEAKER
                  ? item.streamId
                  : item.role === ROLE.LISTENER
                  ? item.rStreamId || item.streamId
                  : ''
            }
          ]
        }
      })
      this.classroomListFictitious = list
      // 订阅所有的流：
      this.initStream(this.classroomListFictitious)
    },
    getSpeakerCardList(speakerCardList) {
      this.speakerCardList = speakerCardList
      this.getClassroomListFictitious()
    },
    getListenerCardList(listenerCardList) {
      this.listenerCardList = listenerCardList
      this.getClassroomListFictitious()
    },
    operationDOMRightList() {
      // 处理右边的画面：
      this.$nextTick(() => {
        this.speakerCardList.forEach((item, index) => {
          const domVideo = document.querySelector(`#speakerClassroom_${index}`)
          const videoStreamId = item.streamId
          if (domVideo) {
            if (domVideo.srcObject !== this.streamMap.get(videoStreamId)) {
              domVideo.srcObject = this.streamMap.get(videoStreamId)
            }
          }
        })
        this.listenerCardList.forEach((item, index) => {
          const domVideo = document.querySelector(`#listenerClassroom_${index}`)
          const videoStreamId = item.streamId
          if (domVideo) {
            if (domVideo.srcObject !== this.streamMap.get(videoStreamId)) {
              domVideo.srcObject = this.streamMap.get(videoStreamId)
            }
          }
        })
      })
    },
    // 取消订阅视频流
    async unsubscribeVideo(card) {
      const { streamCard, id } = card
      const res = await this.clientForZRTC.unsubscribe(streamCard.streamId)
      this.streamMap.delete(streamCard.streamId, res)
      this.operationDOM()
      this.operationDOMRightList()
    },
    // 订阅视频流
    async subscribeVideo(card) {
      const { streamCard, id } = card
      const res = await this.clientForZRTC.subscribe(streamCard.streamId, undefined, VIDEO_LEVEL.MID)
      this.streamMap.set(res.streamId, res)
      this.operationDOM()
      this.operationDOMRightList()
    }
  }
}
</script>
<style>
html,
body {
  font-size: 62.5%;
}
@media screen and (max-width: 1300px) {
  html,
  body {
    font-size: 52.5%;
  }
}
</style>
<style lang="scss" scoped>
.station-container-outer {
  position: relative;
  padding-top: 56.25%; // 9/16
  overflow: hidden;
}
.station-container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #f6f8fa;
  // width: 120rem;
  // height: 67.5rem;
  // overflow: auto;
  // border: 1px solid red;
}
.station-body-container {
  height: calc(100% - 6.6rem);
  .station-body {
    height: 100%;
  }
  .body-left {
    padding-right: 1.6rem;
    height: 100%;
    .display-screen {
      margin-bottom: 1.6rem;
      padding-top: 56.25%; // 16/9
      position: relative;
      .main-player {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
      }
    }
    .layout-list-wrap {
      background: #fff;
      padding: 1rem 0 0; // 2.0rem 0
      height: calc(100% - 1rem);
      .layout-tip {
        text-align: left;
        padding-left: 2rem;
        margin-bottom: 0.8rem; // 1.6rem
        color: #1e2228;
        font-size: 1.4rem;
        span {
          margin-right: 2rem;
        }
      }
    }
  }
  .body-right {
    background: #fff;
    height: 100%;
    .tab-list {
      height: 6rem;
      padding: 0 1rem;
      text-align: left;
      font-weight: bold;
    }
    .tab-content-wrap {
      height: calc(100% - 6rem);
      overflow-y: scroll;
    }
  }
}
</style>
